import { render, staticRenderFns } from "./transportadora.vue?vue&type=template&id=4c4de819"
import script from "./transportadora.ts?vue&type=script&lang=js&external"
export * from "./transportadora.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c4de819')) {
      api.createRecord('4c4de819', component.options)
    } else {
      api.reload('4c4de819', component.options)
    }
    module.hot.accept("./transportadora.vue?vue&type=template&id=4c4de819", function () {
      api.rerender('4c4de819', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/nfe/transportadora.vue"
export default component.exports